import React from 'react';
import { Container } from '@material-ui/core';
import { useRouteMatch, Route, Switch } from 'react-router-dom';

import Areas from './Areas/Areas';
import AreaView from './AreaView/AreaView';

const AreasOfLawPractices = () => {
	const { url } = useRouteMatch();
	return (
		<Container maxWidth='false'>
			<Switch>
				<Route path={`${url}/:area`}>
					<AreaView />
				</Route>
				<Route path={`${url}`}>
					<Areas imgMode={false} showButton={false} />
				</Route>
			</Switch>
		</Container>
	);
};

export default AreasOfLawPractices;
